import React, { Component } from "react";
import ShiftConfigurationForm from "../ShiftConfigurationForm/ShiftConfigurationForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : ShiftConfigurationPage
Description : Componente que invoca al componente ShiftConfigurationForm
Date Autor Modification
================================================================================
14/04/2026 scoca – Creacióm
================================================================================ */
class ShiftConfigurationPage extends Component {
    render() {
        return (
            <ShiftConfigurationForm />
        )
    }
}

export default ShiftConfigurationPage;